import { AreaState, AreaStateEditModeEnum, ActionState, ActionStateEnum, } from "..";
import { EntityManager } from "../../plan/EntityManager";

import { Utils } from "../../utils/Utils";
import { Command } from "../../../../constants";
import { PlanManager } from "../../../../cocosPlan";
import { Area, Commands, ComponentConstants, Entity, EntityDefaultPropertiesManager, EntityFactory, Events, eventsManager, Floor, KitchenTool, Listener, math, planManager, Room, roomManager, SavaneMath, SceneConstants, WorkTop } from "@rhinov/savane-js";

declare var cc: any;


export class WorkTopState extends AreaState {

    ctrlPressed = false;
    _previousLineIndex: number | null = null;
    _previousPointIndex: number | null = null;
    _updateCoating: Listener | null = null;
    _toggleLeg: Listener | null = null;
    _toggleCredence: Listener | null = null;
    hoveredWorktop: WorkTop | null = null;

    constructor() {
        super(null as any, null);
        this.state = ActionStateEnum.DrawWorkTop;
        this._allowColinearVertices = true;

        PlanManager.getInstance().updateItemsSelected(null);

        

        /**
         * Segment selected
         * @type {null}
         * @private
         */
        this._entity = null;

        this._updateCoating = eventsManager.instance.addListener(Events.UPDATE_WORK_TOP_COATING, (event: any) => {
            if (this._entity !== null) {
                var i;
                if (event.getUserData().coating !== null &&
                    event.getUserData().coating.componentType === ComponentConstants.ComponentType.Coating) {
                    for (i = this._entity.components.length - 1; i >= 0; i--) {
                        if (this._entity.components[i].componentType === ComponentConstants.ComponentType.Coating) {
                            this._entity.components.splice(i, 1);
                        }
                    }

                    this._entity.addComponent(event.getUserData().coating);
                }
                if (event.getUserData().credence !== null &&
                    event.getUserData().credence.componentType === ComponentConstants.ComponentType.Credence) {
                    for (i = this._entity.components.length - 1; i >= 0; i--) {
                        if (this._entity.components[i].componentType === ComponentConstants.ComponentType.Credence &&
                            event.getUserData().credenceIndex === (this._entity.components[i] as {credenceIndex?: any}).credenceIndex) {
                            this._entity.components.splice(i, 1);
                            continue;
                        }
                        if (this._entity.components[i].componentType === ComponentConstants.ComponentType.Credence && (event.getUserData().credenceIndex === null)) {
                            this._entity.components.splice(i, 1);
                        }
                    }

                    this._entity.addComponent(event.getUserData().credence);
                }
            }
        });

        this._toggleLeg = eventsManager.instance.addListener(Events.TOOGLE_WORK_TOP_LEG, (event: any) => {
            if (this._entity !== null && this._previousLineIndex !== null) {
                var begin = math.vec3.clone(this._area!.vertices[this._previousLineIndex]);
                var end = math.vec3.clone(this._area!.vertices[(this._previousLineIndex + 1) % this._area!.vertices.length]);
                var beginIdx = this._previousLineIndex;
                var endIdx = (this._previousLineIndex + 1) % this._area!.vertices.length;
                var found = false;
                for (var i = 0; i < (this._entity as WorkTop).legs.length; i++) {
                    if ((this._entity as WorkTop).legs[i].areaBeginIndex === beginIdx &&
                        (this._entity as WorkTop).legs[i].areaEndIndex === endIdx) {
                        found = true;
                        PlanManager.getInstance().executeCommand(this.editCommand([{
                            deletedLeg: i
                        }]));
                        break;
                    }
                }

                if (!found) {
                    PlanManager.getInstance().executeCommand(this.editCommand([{
                        legBegin: begin, legEnd: end, isUnder: true //event.getUserData().isUnder
                    }]));
                }
            }
        });

        this._toggleCredence = eventsManager.instance.addListener(Events.TOOGLE_WORK_TOP_CREDENCE, (event: any) => {
            if (this._entity !== null && this._previousLineIndex !== null) {
                var begin = math.vec3.clone(this._area!.vertices[this._previousLineIndex]);
                var end = math.vec3.clone(this._area!.vertices[(this._previousLineIndex + 1) % this._area!.vertices.length]);
                var beginIdx = this._previousLineIndex;
                var endIdx = (this._previousLineIndex + 1) % this._area!.vertices.length;
                var found = false;
                for (var i = 0; i < (this._entity as WorkTop).credences.length; i++) {
                    if ((this._entity as WorkTop).credences[i].areaBeginIndex === beginIdx &&
                        (this._entity as WorkTop).credences[i].areaEndIndex === endIdx) {
                        found = true;
                        PlanManager.getInstance().executeCommand(this.editCommand([{
                            deletedCredence: i
                        }]));
                        break;
                    }
                }

                if (!found) {
                    PlanManager.getInstance().executeCommand(this.editCommand([{
                        credenceBegin: begin, credenceEnd: end
                    }]));
                }
            }
        });

        KitchenTool.KitchenManager.worktopRoutine(PlanManager.getInstance().world.currentScene!.currentFloor!);

        this.init();
    }

    getAction(): number {
        return ActionStateEnum.DrawWorkTop;
    }

    isDecorationState(): boolean {
        return (true);
    }

    editPoint(index: number, position: math.vec3, nosnap: boolean) {
        if (this._entity !== null) {
            if (PlanManager.getInstance().snapEnabled) {
                var newPosition = super.editPoint(index, position, nosnap);
                if (newPosition === position && !nosnap) {
                    const magnetPos = planManager.getMagnetPositionWorktop(position, PlanManager.getInstance().world.currentScene!.currentFloor!, Utils.magnetDistance);
                    position = magnetPos || position;
                } else {
                    position = newPosition as math.vec3;
                }
                //Set height to worktop
                if (position[2] > (this._area!.entity! as WorkTop).maxHeight * 10 - (this._area!.entity! as WorkTop).thickness) {
                    (this._area!.entity! as WorkTop).maxHeight = (position[2] + (this._area!.entity! as WorkTop).thickness) / 10;
                }
            }
            (this._area!.entity as WorkTop).setVertice(index, position);
        }
    }

    nextState(): ActionState | null {
        return null;
    }

    init() {
        this._editedLineIndex = null;
        this._editedPointIndex = null;
        this.hoveredWorktop = null;
        this.isAreaCreated = false;
        this._isDrawingPoint = false;
        this.editMode = AreaStateEditModeEnum.unknown;

        eventsManager.instance.dispatch(Events.SET_WORK_TOP, this._entity);
    }

    getAreaSelectionMode(cursorPosition: math.vec3, doubleClick: boolean): number {
        return (super.getAreaSelectionMode(cursorPosition, doubleClick));
    }

    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        if (keyCode === cc.KEY.ctrl || ctrl) {
            this.ctrlPressed = true;
        }

        if (keyCode === cc.KEY.s) {
            PlanManager.getInstance().toggleSnap();
        }

        if (keyCode === cc.KEY.l) {
            if (this._previousLineIndex !== null) {
                eventsManager.instance.dispatch(Events.TOOGLE_WORK_TOP_LEG, this._entity);
            }
        }

        if (keyCode === cc.KEY.c) {
            if (this._previousLineIndex !== null) {
                eventsManager.instance.dispatch(Events.TOOGLE_WORK_TOP_CREDENCE, this._entity);
            } else {
                return this._makeCircle();
            }
        }

        if (keyCode === cc.KEY.e) {
            return this._makeElipse();
        }

        if (keyCode === cc.KEY.escape) {
            if (this._area !== null && this._node !== null && !this._node.isClosed()) {
                EntityManager.getInstance().deleteNode(this._area!.entity!.id);

                this._entity = null;
                this.init();
            }

            return null;
        }

        if (keyCode === cc.KEY.left || keyCode === cc.KEY.right || keyCode === cc.KEY.up || keyCode === cc.KEY.down) {
            var offset = 1;
            var index = 0;

            if (keyCode === cc.KEY.left || keyCode === cc.KEY.down) {
                offset = -1;
            }
            if (keyCode === cc.KEY.up || keyCode === cc.KEY.down) {
                index = 1;
            }

            if (this._editedPointIndex !== null) {
                eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
                var position = this._area!.vertices[this._editedPointIndex];
                this._savedPosition = math.vec3.clone(position)
                position[index] += offset;
                (this._area!.entity as WorkTop).setVertice(this._editedPointIndex, position);
            }
            if (this._editedLineIndex !== null) {
                eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
                this._savedPositions = [];
                var position = this._area!.vertices[this._editedLineIndex];
                this._savedPositions.push(math.vec3.clone(position));
                position[index] += offset;
                (this._area!.entity as WorkTop).setVertice(this._editedLineIndex, position);
                var position = this._area!.vertices[(this._editedLineIndex + 1) % this._area!.vertices.length];
                this._savedPositions.push(math.vec3.clone(position));
                position[index] += offset;
                (this._area!.entity as WorkTop).setVertice((this._editedLineIndex + 1) % this._area!.vertices.length, position);
            }
        }

        return super.keyPressed(keyCode, ctrl, alt);
    }

    _makeCircle(): ActionState | null {
        if (this._area!.vertices.length < 3) {
            return null;
        }

        var center = math.vec3.create();
        math.vec3.add(center, this._area!.vertices[0], this._area!.vertices[1]);
        math.vec3.divide(center, center, math.vec3.fromValues(2, 2, 2));
        var radius = math.vec3.distance(this._area!.vertices[0], this._area!.vertices[1]) / 2;
        var tanStep = 60;
        var angleStep = Math.atan(tanStep / radius);
        var newVertices = [];
        for (var step = 0; step < 2 * Math.PI; step += angleStep) {
            newVertices.push(math.vec3.fromValues(center[0] + radius * Math.cos(step), center[1] + radius * Math.sin(step), center[2]));
        }

        var newArea = this._area!.clone();
        newArea.vertices = newVertices;
        PlanManager.getInstance().executeCommand(new Commands.ReplaceComponentCommand(this._area!, newArea, this._entity!));
        return this.nextState();
    }

    _makeElipse(): ActionState | null {
        if (this._area!.vertices.length < 3) {
            return null as any;
        }

        var center = math.vec3.create();
        math.vec3.add(center, this._area!.vertices[0], this._area!.vertices[1]);
        math.vec3.divide(center, center, math.vec3.fromValues(2, 2, 2));
        var a = math.vec3.distance(this._area!.vertices[0], this._area!.vertices[1]) / 2;
        var b = math.vec3.distance(this._area!.vertices[0], this._area!.vertices[2]);
        var x = math.vec3.create();
        math.vec3.subtract(x, this._area!.vertices[1], this._area!.vertices[0]);
        math.vec3.normalize(x, x);
        var y = math.vec3.create();
        math.vec3.subtract(y, this._area!.vertices[2], this._area!.vertices[0]);
        math.vec3.normalize(y, y);
        var z = math.vec3.create();
        math.vec3.cross(z, y, x);
        math.vec3.cross(y, x, z);
        var frame = math.mat4.fromValues(
            x[0], x[1], x[2], 0,
            y[0], y[1], y[2], 0,
            z[0], z[1], z[2], 0,
            center[0], center[1], center[2], 1);
        var tanStep = 60;
        var angleStep = Math.atan(tanStep / a);
        var newVertices = [];
        for (var step = 0; step < 2 * Math.PI; step += angleStep) {
            var position = math.vec3.fromValues(a * Math.cos(step), b * Math.sin(step), 0);
            math.vec3.transformMat4(position, position, frame);
            newVertices.push(position);
        }

        var newArea = this._area!.clone();
        newArea.vertices = newVertices;
        PlanManager.getInstance().executeCommand(new Commands.ReplaceComponentCommand(this._area!, newArea, this._entity!));
        return this.nextState();
    }

    _updateWebGlDynamicHull() {
        // Inform WebGL to update the dynamic hull
        eventsManager.instance.dispatch(Events.COMMAND_EXECUTED, {
            name: Commands.CommandEnum.EditComponentCommand,
            undo: false,
            datas: {
                component: this._area
            }
        });
    }

    keyUnPressed(keyCode: number, ctrl?: boolean, maj?: boolean): ActionState | null {
        if (keyCode == cc.KEY.ctrl) {
            this.ctrlPressed = false;
        }

        if (keyCode === cc.KEY.left || keyCode === cc.KEY.right || keyCode === cc.KEY.up || keyCode === cc.KEY.down) {
            if (this._editedPointIndex !== null) {
                var begin = this._savedPosition;
                var end = math.vec3.clone(this._area!.vertices[this._editedPointIndex]);
                PlanManager.getInstance().executeCommand(this.editCommand([{
                    begin: begin,
                    end: end,
                    index: this._editedPointIndex
                }]));
            } else if (this._editedLineIndex !== null) {
                var editParams = [
                    {
                        begin: this._savedPositions![0],
                        end: math.vec3.clone(this._area!.vertices[this._editedLineIndex]),
                        index: this._editedLineIndex
                    },
                    {
                        begin: this._savedPositions![1],
                        end: math.vec3.clone(this._area!.vertices[(this._editedLineIndex + 1) % this._area!.vertices.length]),
                        index: (this._editedLineIndex + 1) % this._area!.vertices.length
                    }
                ];
                PlanManager.getInstance().executeCommand(this.editCommand(editParams));
            }
        }

        return super.keyUnPressed(keyCode, ctrl, maj);
    }

    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        if (this._entity === null) {
            var hovered = planManager.getWorktopAtPosition(cursorPosition, PlanManager.getInstance().world.currentScene!.currentFloor!, this.ctrlPressed);
            if (hovered !== this.hoveredWorktop) {
                if (this.hoveredWorktop !== null) {
                    var node = EntityManager.getInstance().getNode(this.hoveredWorktop);
                    if (node) {
                        node.setHovered(false);
                    }
                }
                this.hoveredWorktop = hovered;
                if (this.hoveredWorktop !== null) {
                    var node = EntityManager.getInstance().getNode(this.hoveredWorktop);
                    if (node) {
                        node.setHovered(true);
                    }
                }
            }
        }

        if (this.editMode === AreaStateEditModeEnum.unknown) {
            return (null);
        }

        return super.moveMouseCursor(cursorPosition);
    }

    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        if (this.editMode === AreaStateEditModeEnum.area_selected && this._isEditing) {
            this._updateWebGlDynamicHull();
        }

        var res = super.mouseClickUp(cursorPosition, elapsedTime, hoverEntities, mouseButton);

        if ((this._node as any) !== null) {
            if (this._node!.areaNode === null) {
                EntityManager.getInstance().deleteNode(this._area!.entity!.id);
                this._entity = null;
                this.init();
            }
        }

        if (!this._isDrawingPoint) {
            KitchenTool.KitchenManager.worktopRoutine(PlanManager.getInstance().world.currentScene!.currentFloor!);
            eventsManager.instance.dispatch(Events.COMPONENT_EDITED, this._area!);
        }

        return res;
    }

    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        if (mouseButton === 2) {
            return PlanManager.getInstance().mouseClickCancelled();
        }
        
        this._lastCursorPosition = null;
        this._dragging = false;

        if (this._entity !== null && this._node !== null && this._node.isClosed()) {
            this._entity = null;
            this._node.setSelected(false);
            this._node = null;
        }

        if (this._previousLineIndex !== null) {
            this._previousLineIndex = null;
            this._editedLineIndex = null;
            eventsManager.instance.dispatch(Events.SELECT_AREA_LINE, {
                area: this._area,
                line: null
            });
        }

        if (this._previousPointIndex !== null) {
            this._previousPointIndex = null;
            this._editedPointIndex = null;
            eventsManager.instance.dispatch(Events.SELECT_AREA_POINT, {
                area: this._area,
                point: null
            });
        }

        if ((this._entity === null) || (this._node !== null && this._node.isClosed())) {
            var hovered: WorkTop | null = null;
            hovered = planManager.getWorktopAtPosition(cursorPosition, PlanManager.getInstance().world.currentScene!.currentFloor!, this.ctrlPressed);
            var area: any = null;

            if (hovered !== null) {
                area = hovered.getComponent(ComponentConstants.ComponentType.Area);
            }

            super.init(area, cursorPosition, hovered as any, doubleClick);
            this._allowColinearVertices = true;

            if (hovered === null) {
                this._entity = EntityFactory.getInstance().createWorkTop(KitchenTool.KitchenToolConstants.workTopDefaultThickness);
                this._entity.parent = PlanManager.getInstance().world.currentScene!.currentFloor!;
                var component = EntityDefaultPropertiesManager.getInstance().coating;
                if (component !== null) {
                    this._entity.addComponent(component);
                }
                component = EntityDefaultPropertiesManager.getInstance().credence;
                if (component !== null) {
                    this._entity.addComponent(component);
                }
                //Create worktop node
                this._node = EntityManager.getInstance().addEntity(this._entity) as any;
                (this._node as any).setClosed(false);
                (this._node as any).setSelected(true);
                //TODO to remove
                this._area = this._entity.getComponent(ComponentConstants.ComponentType.Area) as Area;
                this._area.vertices = [cursorPosition, cursorPosition];
                //Begin drawing state
                this.isAreaCreated = true;
                this._isDrawingPoint = true;

                var arrangementObjects = PlanManager.getInstance().world.currentScene!.currentFloor!.iArrangements;
                for (var i = 0; i < arrangementObjects.length; i++) {
                    var arr = arrangementObjects[i];
                    var remove = false;

                    if (arr.isArrangementGroupEntity()) {
                        remove = true;
                    }
                    else {
                        if (!SavaneMath.isInPoly(cursorPosition, arr.boundingBox)) {
                            remove = true;
                        }
                        else {
                            if (arr.isTechnicalElementEntity()) {
                                if ((arr.objectId === SceneConstants.TechnicalElementType.rosette ||
                                    arr.objectId === SceneConstants.TechnicalElementType.beam ||
                                    arr.objectId === SceneConstants.TechnicalElementType.guardrail ||
                                    arr.objectId === SceneConstants.TechnicalElementType.frame ||
                                    arr.objectId === SceneConstants.TechnicalElementType.spotLight ||
                                    arr.objectId === SceneConstants.TechnicalElementType.airConditioner) && (PlanManager.getInstance()._hideAxo))
                                {
                                    remove = true;
                                }
                            }
                        }
                    }

                    if (remove) {
                        arrangementObjects.splice(i, 1);
                    }
                }

                this._entity.floorHeight = KitchenTool.KitchenToolConstants.workTopDefaultHeight - KitchenTool.KitchenToolConstants.workTopDefaultThickness;
            }
            else {
                this._entity = hovered;
                this._area = area;
                this._node = EntityManager.getInstance().getNode(this._entity) as any;
                this.hoveredWorktop = hovered;
            }
        }

        var res = super.mouseClickDown(cursorPosition, doubleClick, hoverEntities, mouseButton, false);

        if (this._editedLineIndex !== null) {
            this._previousLineIndex = this._editedLineIndex;
            eventsManager.instance.dispatch(Events.SELECT_AREA_LINE, {
                area: this._area,
                line: this._editedLineIndex
            });
            eventsManager.instance.dispatch(Events.SET_WORK_TOP, this._entity);
            eventsManager.instance.dispatch(Events.SET_WORK_TOP_EDGE, this._editedLineIndex);
        } else if (this._editedPointIndex !== null) {
            this._previousPointIndex = this._editedPointIndex;
            eventsManager.instance.dispatch(Events.SELECT_AREA_POINT, {
                area: this._area,
                point: this._editedPointIndex
            });
        } else if (this._entity !== null) {
            if (this._node !== null && this._node.isClosed()) {
                this._node.setSelected(true);
                this.editMode = AreaStateEditModeEnum.area_selected;
                this._isEditing = true;
                eventsManager.instance.dispatch(Events.SET_WORK_TOP, this._entity);
            }
        } else {
            eventsManager.instance.dispatch(Events.SET_WORK_TOP_EDGE, null);
            eventsManager.instance.dispatch(Events.SET_WORK_TOP, null);
        }

        return res;
    }

    deleteCommand(): Command {
        var command = new Commands.DeleteEntityCommand(this._entity!, false);
        this.init();
        eventsManager.instance.dispatch(Events.SET_WORK_TOP, null);
        return command;
    }

    editCommand(param: any): Command {
        return new Commands.EditComponentCommand(this._area!, param);
    }

    addCommand(): Command {
        var parent = roomManager.getRoomAtPosition(this._area!.vertices[0], PlanManager.getInstance().world.currentScene!.currentFloor!) as Room | Floor;

        //No parent found
        if (parent === null) {
            parent = PlanManager.getInstance().world.currentScene!.currentFloor!;
        }

        var floor: any = parent;
        while (floor && floor instanceof Floor === false) {
            floor = floor.parent;
        }
        const floorHeight = floor?.height ?? 0;
        if (floorHeight < 0) {
            this._area!.entity!.transform.localMatrix[14] = floorHeight + this._area!.entity!.transform.localMatrix[14];
        } else {
            this._area!.entity!.transform.localMatrix[14] += floorHeight;
        }

        parent = parent || PlanManager.getInstance().world.currentScene!.currentFloor!;
        var res = new Commands.AddEntityCommand(this._area!.entity!, parent, true, false);
        if (res) {
            this._node!.setClosed(true);
        }
        eventsManager.instance.dispatch(Events.COMPONENT_EDITED, this._area!);

        return res;
    }

    mouseClickCancelled(cursorPosition: math.vec3): ActionState | null {
        super.mouseClickCancelled(cursorPosition);

        if (this._area !== null && this._node !== null && !this._node.isClosed()) {
            EntityManager.getInstance().deleteNode(this._area!.entity!.id);

            this._entity = null;
            this.init();
        }

        return null;
    }

    actionEditEnded() {
    }

    dispose() {
        //FIXME how to know if proceed or not ?
        if (this._area !== null) {
            if (this._node !== null && !this._node.isClosed()) {
                EntityManager.getInstance().deleteNode(this._area!.entity!.id);
            }
        }
        eventsManager.instance.dispatch(Events.SELECT_AREA_LINE, {
            area: this._area,
            line: null
        });
        eventsManager.instance.dispatch(Events.SELECT_AREA_POINT, {
            area: this._area,
            point: null
        });
        if (this._toggleLeg !== null) eventsManager.instance.removeListener(this._toggleLeg);
        if (this._toggleCredence !== null) eventsManager.instance.removeListener(this._toggleCredence);
        if (this._updateCoating !== null) eventsManager.instance.removeListener(this._updateCoating);
        this._entity = null;
        //Clean selected
        if (this._node !== null) {
            this._node.setSelected(false);
        }
        //Remove hover
        if (this.hoveredWorktop !== null) {
            var node = EntityManager.getInstance().getNode(this.hoveredWorktop);
            if (node !== null) {
                node.setHovered(false);
            }
        }

        PlanManager.getInstance().updateItemsSelected(null);
    }

}
